import { ContentItem } from "../ContentItem/ContentItem";
import { ContentParent } from "../ContentParent";
import { Translate } from "components/common/Translate/Translate";
import { getCDNIcon } from "../ImageResizerContent/ImageResizerContent";
import { translateFunc } from "client/utils/translateFunc";

export const FlipContent = () => {
    return (
        <div className="mx-auto my-20" style={{ maxWidth: "840px" }}>
            <ContentParent>
                <ContentItem
                    title={<Translate keyName="content-easy-title" />}
                    description={<Translate keyName="content-easy-sub-title" />}
                    icon={getCDNIcon("/lightning-fast.svg", translateFunc("common:lightning-fast-alt"))}
                />
                <ContentItem
                    title={<Translate keyName="content-secure-title" />}
                    description={<Translate keyName="content-secure-sub-title" />}
                    icon={getCDNIcon("/privacy-guaranteed.svg", translateFunc("common:privacy-guaranteed-alt"))}
                />
                <ContentItem
                    title={<Translate keyName="content-fast-title" />}
                    description={<Translate keyName="content-fast-sub-title" />}
                    icon={getCDNIcon("/heart.svg", translateFunc("common:heart-alt"))}
                />
            </ContentParent>
        </div>
    );
};
